export default __webpack_public_path__ + "static/media/arrow.048d47fd.svg";